/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Freegamesdesc2Inputs */

const id_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan notifikasi saat game gratis baru tersedia`)
};

const ms_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan pemberitahuan apabila permainan percuma baharu tersedia`)
};

const da_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få besked når nye gratis spil er tilgængelige`)
};

const de_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung erhalten, wenn neue kostenlose Spiele verfügbar sind`)
};

const en_us2_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified when new free games are available`)
};

const es_es2_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe notificaciones cuando haya nuevos juegos gratis disponibles`)
};

const es_mx2_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe notificaciones cuando haya nuevos juegos gratis disponibles`)
};

const fil_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maabisuhan kapag may bagong libreng laro na available`)
};

const fr_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez notifié lorsque de nouveaux jeux gratuits sont disponibles`)
};

const it_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi notifiche quando nuovi giochi gratuiti sono disponibili`)
};

const hu_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítés, amikor új ingyenes játékok érhetők el`)
};

const nl_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvang een melding wanneer er nieuwe gratis games beschikbaar zijn`)
};

const no_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli varslet når nye gratis spill er tilgjengelige`)
};

const pl_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrzymuj powiadomienia, gdy dostępne są nowe darmowe gry`)
};

const pt_br2_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified when new free games are available`)
};

const pt_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba notificações quando novos jogos grátis estiverem disponíveis`)
};

const ro_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primește notificări când sunt disponibile noi jocuri gratuite`)
};

const fi_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ilmoituksen, kun uusia ilmaispelejä on saatavilla`)
};

const sv_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få notiser när nya gratis spel är tillgängliga`)
};

const vi_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận thông báo khi có game miễn phí mới`)
};

const tr_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ücretsiz oyunlar mevcut olduğunda bildirim alın`)
};

const cs_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostávejte oznámení, když jsou k dispozici nové hry zdarma`)
};

const bg_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получавайте известия, когато има нови безплатни игри`)
};

const ru_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте уведомления о новых бесплатных играх`)
};

const uk_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримуйте сповіщення про нові безкоштовні ігри`)
};

const ar_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على إشعار عند توفر ألعاب مجانية جديدة`)
};

const hi_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब नए मुफ़्त गेम उपलब्ध हों तो सूचित करें`)
};

const th_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับการแจ้งเตือนเมื่อมีเกมฟรีใหม่`)
};

const ja_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい無料ゲームが利用可能になったら通知`)
};

const zh_cn2_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified when new free games are available`)
};

const zh_hant1_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified when new free games are available`)
};

const ko_notifications_simple_freegamesdesc2 = /** @type {(inputs: Notifications_Simple_Freegamesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 무료 게임을 이용할 수 있을 때 알림 받기`)
};

/**
* | output |
* | --- |
* | "Get notified when new free games are available" |
*
* @param {Notifications_Simple_Freegamesdesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_freegamesdesc2 = /** @type {((inputs?: Notifications_Simple_Freegamesdesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Freegamesdesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_freegamesdesc2(inputs)
	if (locale === "ms") return ms_notifications_simple_freegamesdesc2(inputs)
	if (locale === "da") return da_notifications_simple_freegamesdesc2(inputs)
	if (locale === "de") return de_notifications_simple_freegamesdesc2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_freegamesdesc2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_freegamesdesc2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_freegamesdesc2(inputs)
	if (locale === "fil") return fil_notifications_simple_freegamesdesc2(inputs)
	if (locale === "fr") return fr_notifications_simple_freegamesdesc2(inputs)
	if (locale === "it") return it_notifications_simple_freegamesdesc2(inputs)
	if (locale === "hu") return hu_notifications_simple_freegamesdesc2(inputs)
	if (locale === "nl") return nl_notifications_simple_freegamesdesc2(inputs)
	if (locale === "no") return no_notifications_simple_freegamesdesc2(inputs)
	if (locale === "pl") return pl_notifications_simple_freegamesdesc2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_freegamesdesc2(inputs)
	if (locale === "pt") return pt_notifications_simple_freegamesdesc2(inputs)
	if (locale === "ro") return ro_notifications_simple_freegamesdesc2(inputs)
	if (locale === "fi") return fi_notifications_simple_freegamesdesc2(inputs)
	if (locale === "sv") return sv_notifications_simple_freegamesdesc2(inputs)
	if (locale === "vi") return vi_notifications_simple_freegamesdesc2(inputs)
	if (locale === "tr") return tr_notifications_simple_freegamesdesc2(inputs)
	if (locale === "cs") return cs_notifications_simple_freegamesdesc2(inputs)
	if (locale === "bg") return bg_notifications_simple_freegamesdesc2(inputs)
	if (locale === "ru") return ru_notifications_simple_freegamesdesc2(inputs)
	if (locale === "uk") return uk_notifications_simple_freegamesdesc2(inputs)
	if (locale === "ar") return ar_notifications_simple_freegamesdesc2(inputs)
	if (locale === "hi") return hi_notifications_simple_freegamesdesc2(inputs)
	if (locale === "th") return th_notifications_simple_freegamesdesc2(inputs)
	if (locale === "ja") return ja_notifications_simple_freegamesdesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_freegamesdesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_freegamesdesc2(inputs)
	return ko_notifications_simple_freegamesdesc2(inputs)
});
export { notifications_simple_freegamesdesc2 as "notifications.simple.freeGamesDesc" }